import Password from "../../../../../components/Password/Password";
import React, {useState} from "react";
import '../../../assets/ChangePasswordModal.scss'
import {ChangePasswordModalState} from "./interfaces/ChangePasswordModalState";
import ChangePasswordModalController from "./controller/ChangePasswordModalController";
import {useTranslation} from "react-i18next";

export default function ChangePasswordModal() {
    const {t} = useTranslation();
    const [state, setState] = useState<ChangePasswordModalState>({
        prevPassword: "",
        newPassword: "",
        confirmNewPassword: "",
    })
    const passwordFields = [
        {
            keyState: "prevPassword",
            setState,
            label: t("setting.currentPassword"),
            placeholder: t("setting.currentPassword"),
        },
        {
            keyState: "newPassword",
            setState,
            label: t("setting.newPassword"),
            placeholder: t("setting.newPassword"),
        },
        {
            keyState: "confirmNewPassword",
            setState,
            label: t("setting.confirmNewPassword"),
            placeholder: t("setting.confirmNewPassword"),
        },
    ]

    return (
        <div className={'change-password-modal'}>
            <h2>{t("setting.changePassword")}</h2>
            <form onSubmit={e => new ChangePasswordModalController(state, setState).submitForm(e)}>
                {passwordFields.map(field => (
                    <Password key={field.keyState}
                              setState={field.setState}
                              label={field.label}
                              placeholder={field.placeholder}
                              keyState={field.keyState}/>
                ))}
                {state.error ?
                    <div className="error-change-password-modal">
                        <p>{state.message}</p>
                    </div>
                    : null}
                <div className="footer-change-password-modal">
                    <button type={'button'} onClick={() => window.dispatchEvent(new Event('closeModal'))}>
                        {t("close")}
                    </button>
                    <button type="submit">{t("setting.changePassword")}</button>
                </div>
            </form>
        </div>
    )
}